import { Skeleton } from '@mui/material';
import { useGatewayCardContext } from '../gateway-card.context';
import { Styled } from '../gateway-card.styled';

const Header: React.FC = () => {
    const {
        loading,
        gateway: { avatar, avatar_color, title },
    } = useGatewayCardContext();

    return (
        <Styled.AvatarWrapper>
            <Styled.Avatar
                alt={title}
                src={avatar}
                sx={{
                    background: avatar_color,
                    color: 'primary.contrastText',
                    borderRadius: '10px',
                }}>
                {loading ? (
                    <Skeleton variant="circular" width="100%" height="100%" />
                ) : (
                    title.substring(0, 1)
                )}
            </Styled.Avatar>
        </Styled.AvatarWrapper>
    );
};

export default Header;
